<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Mis permisos generados
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close
    .is-desktop
      .body
        table.table.is-striped.is-bordered
          thead
            th Tipo
            th Motivo
            th Fecha
            th Adjunto
          tbody(
            name="table-row"
            is="transition-group"
          )
            tr.row-table(
              v-for="(o, index) in lista"
              :key="index"
            )
              td
                span.hint--top(:aria-label="'Solicitud: ' + o.idSolicitud") {{ o.descripcionTipo }}
              td {{ o.motivo }}
              td
                .detalle
                  .flex {{ o.desde === o.hasta ? o.desde : `${o.desde} - ${o.hasta}` }}&nbsp;
                  strong.flex {{ o.horaDesde }} - {{ o.horaHasta }}
              td.text-center
                template(v-if="o.adjunto")
                  a.button.is-small(:href="o.adjunto", target="_blank")
                    span.icon.is-small
                      i.fa.fa-paperclip.is-small.fs-12
                    span Ver adjunto
                template(v-else)
                  span Sin adjunto
        loading(v-if="isLoading")
    .is-mobile
      loading(v-if="isLoading")
      .box(
        v-for="(o, index) in lista"
        :key="index"
      )
        .descripcion-tipo.hint--top(:aria-label="'Solicitud: ' + o.idSolicitud")
          span {{ o.descripcionTipo }}
        .motivo
          div
            span {{ o.motivo }}
        .dias-pedidos
          strong Dias pedidos
          div
            span.detalle-dias {{ o.desde === o.hasta ? o.desde : `${o.desde} - ${o.hasta}` }}   {{ o.horaDesde }}-{{ o.horaHasta }}
        .botones
          template(v-if="o.adjunto")
            a.button.is-small(:href="o.adjunto", target="_blank")
              span.icon.is-small
                i.fa.fa-paperclip.is-small.fs-12
              span Ver adjunto

</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'lista_mis_permisos_component',
  data () {
    return {
      lista: [],
      isLoading:true
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/permisos/empleado/permisos', obj, function (data) {
        if (data.lista.length === 0) {
          vm.lista = []
          vm.$emit('close')
        } else {
          vm.lista = data.lista
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 5px
      right 5px
      cursor pointer
      i
        font-size 16px

    .title
      padding-left: 10px
      padding-right: 10px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    cursor pointer

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }
  .fs-12
    font-size 12px
  .detalle
    display flex
    flex-wrap: wrap;
    justify-content center
  tr
    &.active
      background-color #c1debe !important
    &.resta
      background-color #ffd6d6 !important
    &.suma
      background-color #c1debe !important
  .dias-pedidos
    font-size 12px
    color #9a9a9a
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width 578px)
    .is-mobile
      display block
    .dias-pedidos
      font-size 13px
    .is-desktop
      display none
</style>



// WEBPACK FOOTER //
// Component_Permisos_Lista_Mis_Permisos.vue?52805d37